<div *ngIf="showForm">
    <tilby-magic-form [form]="data.form"/>
</div>
